import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export const URLRedirectHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;

    const match = path.match(
      /^\/passagens-aereas-de-([^/]+)\/([^/]+)\/para-([^/]+)\/([^/]+)$/,
    );

    const hasQueryParams = location.search.includes("origin-airport");

    if (match && !hasQueryParams) {
      const [, originCity, originCode, destinationCity, destinationCode] =
        match;

      const searchParams = new URLSearchParams({
        "origin-airport": originCode,
        "destination-airport": destinationCode,
        "departure-date": "2025-04-24",
        "return-date": "2025-05-23",
        "quantity-of-adults": "1",
        "quantity-of-children": "0",
        "quantity-of-babies": "0",
        "total-expected-requests": "6",
      });

      navigate(`${path}?${searchParams.toString()}`, { replace: true });
    }
  }, [location.pathname, location.search]);

  return null;
};
